import React, { useContext, useRef, useMemo, useState } from 'react'
import isEqual from 'lodash/isEqual'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'components/graphql'
import { ContentBlock } from 'components/ContentBlock'
import RoomInput from './RoomInput'
import { RestaurantContext } from 'sections/options/sections/RestaurantDesigner/RestaurantDesignerHandler'
import { Form, Text } from 'components/forms'
import FakeInput from 'components/FakeInput'
import { ConfirmModal } from 'components/Modal'
import { mutation } from '../../helpers'
import { FloorsContext } from './FloorsBlocksContainers'
import {
	StyledFloorBlockLabel,
	StyledFloorRemove,
	StyledFormInput,
	StyledFloorEdit
} from './styled'


const FloorBlock = (props) => {
	const { mutations: { create: { rawCreateRoom }, update: { rawUpdateRoom }, delete: { rawDeleteFloor } }, query, floorItem, floorKey } = props

	const { currentProjectData, currentProjectIds, setCurrentProjectIds } = useContext(RestaurantContext)
	const { setModalFloor } = useContext(FloorsContext)
	const hasActiveData = !!currentProjectData.floorData
	const api = useRef()
	const [t] = useTranslation()
	const [isFloorExpanded, setFloorExpanded] = useState(hasActiveData && (currentProjectData.floorData.id === currentProjectIds.floorId))
	const [deleteFloor] = useMutation(rawDeleteFloor)
	const [updateRoom] = useMutation(rawUpdateRoom)

	useMemo(()=> {
		if(hasActiveData) {
			setFloorExpanded(currentProjectData.floorData.number === floorItem.number)
		}
	}, [hasActiveData && currentProjectData.floorData.number, floorItem.number])
	const handleBlurRoom = (fields) => {
		let changedElemKey
		const changedElem = floorItem.rooms.find((item, key) => {
			if(!isEqual(item.caption, fields.rooms[key].caption)) {
				changedElemKey = key
				return true
			}
		})
		if (changedElem && changedElem.caption && changedElem.id /*<= it means, changedElem is FakeInput*/) {
			return mutation(updateRoom, {
				fields: {
					id: changedElem.id,
					caption: fields.rooms[changedElemKey].caption
				}
			})
				.then(result => {
					floorItem.rooms[changedElemKey] = result.data.cashAssist.updateRoom[0]
				})
		}
	}

	const handleDeleteFloor = e	=> {
		e.stopPropagation()
		return ConfirmModal({
			show: true,
			label: t('common.buttons.confirm'),
			text: t('restaurant_designer_section.strings.confirm_floor_delete')
		}).then(()=> mutation(deleteFloor, { id: floorItem.id }).then(()=> setCurrentProjectIds({ ...currentProjectIds, floorId: null, roomId: null }))
		)
	}
	const getApi = (formApi) => {
		api.current = formApi
	}

	const floorPath = `floors[${floorKey}]`
	return (
		<ContentBlock key={floorPath} blockId={`${floorItem.number}`} onHeaderClick={ !hasActiveData || (currentProjectData.floorData.number !== floorItem.number) ? (e, isExpanded) => {
			e.stopPropagation()
			const roomId = floorItem.rooms[0] ? floorItem.rooms[0].id : null
			setCurrentProjectIds({ projectId: currentProjectIds.projectId, floorId: floorItem.id, roomId })
			setFloorExpanded(isExpanded)
		} : null}
		alwaysExpanded={(currentProjectIds.floorId === floorItem.id) }
		label={
			<StyledFloorBlockLabel
				onClick={(e)=>{
					e.preventDefault()
				}}>
				{`${t('restaurant_designer_section.strings.floor_title')} ${floorItem.number}`}
				{ (currentProjectIds.floorId && isFloorExpanded) &&	<StyledFloorEdit
					onClick={(e)=>{
						e.stopPropagation()
						setModalFloor(floorItem)
					}} />}
				{ (currentProjectIds.floorId && isFloorExpanded) &&	<StyledFloorRemove onClick={handleDeleteFloor}/>}
			</StyledFloorBlockLabel>
		}>
			<Form
				key={floorItem.rooms.length + floorItem.id}
				smartSubmit
				getApi={getApi}
				onSubmit={(fields)=>handleBlurRoom(fields)}
				initialValues={{
					rooms: [...floorItem.rooms, { caption: '' }]
				}} render={({ formApi })=> (
					<div>
						<>
							{(floorItem.rooms || []).map((roomItem, roomKey) => <RoomInput key={roomItem.id}{...{ handleBlurRoom, floorKey, floorItem, roomItem, roomKey }} {...props} />)}
							<StyledFormInput>
								<FakeInput
									Component={Text}
									label={`${t('restaurant_designer_section.fields.fake_input_label')}`}
									field={`rooms[${floorItem.rooms.length}].caption`}
									fieldName={'caption'}
									additionalFields={{
										projectId: floorItem.projectId,
										floorId: floorItem.id
									}}
									query={query}
									rawCreateRequest={rawCreateRoom}
								/>
							</StyledFormInput>
						</>
					</div>
				)
				} />
		</ContentBlock>
	)
}


export default FloorBlock
